import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
// import ServicesGrid from "../components/ServicesGrid";
// import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import ServiceDetail from "../components/ServiceDetail";

import DynamicAltImage from "../components/DynamicAltImage";



const Home = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
       <DynamicAltImage />
      <ServiceDetail/>
     
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default Home;
